module.exports = __webpack_public_path__ + "img/linkedin.faaafa24.svg";